import React, { useState, useEffect } from 'reactn'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { Center, Alert, AlertIcon, AlertDescription, Box } from '@chakra-ui/react'
import { Dots } from './dotsAnimation'
import "./cartSidebar.css"

const PaymentForm = ({ globalState, setProcessing, setIsReady }) => {
  const { store, updateGlobal } = globalState
  const { fetchingCartData, cartTotal, fullName, contactNumber, emailAddress, processPayment, shipping_address } = store

  const [succeeded, setSucceeded] = useState(false)
  const [error, setError] = useState(null)
  const [disabled, setDisabled] = useState(true)

  const types = {
    accordion: {
      type: "accordion",
      defaultCollapsed: false,
      radios: true,
      spacedAccordionItems: true,
    },
    tabs: {
      type: "tabs",
    },
  }

  const stripe = useStripe()
  const elements = useElements()

  function setProcessPayment(processPayment) {
    updateGlobal({ processPayment: processPayment })
  }

  const handleChange = async (event) => {
    setDisabled(event.complete ? false : true)
    setIsReady(event.complete ? true : false)
    if (event.error) {
      setProcessing(false)
      setError(event.error.message)
    } else {
      setError("")
    }
  }

  useEffect(() => {
    if (processPayment == true) {
      setProcessPayment(false)
      handleCheckout()
    }
  }, [processPayment])

  const handleCheckout = async () => {

    if (!stripe || !elements) {
      return
    }

    const returnURL = process.env.GATSBY_RETURN_URL
    const { error, confirmPayment } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnURL,
        receipt_email: emailAddress,
      },
    })

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setError(error.message)
      } else {
        setError("An unexpected error occured.")
      }
      updateGlobal({ calculating: false, processPayment: false })
      setProcessing(false)
      setSucceeded(false)
    } else {
      setError(null)
      setSucceeded(true)
    }
  }

  return (
    <>
      {!succeeded && (
        <>
          {fetchingCartData ? (
            <Box>
              <Center>
                <Dots mb={5} size="xs" />
              </Center>
            </Box>
          ) : (
            <>
              <form onSubmit={handleCheckout} id="payment">
                {error && (
                  <Alert status="error">
                    <AlertIcon />
                    <AlertDescription>{error}</AlertDescription>
                  </Alert>
                )}
                <Center>
                  <Box mt={2} maxWidth={"600px"} width="100%">
                    <PaymentElement
                      id="payment-element"
                      onChange={handleChange}
                      onReady={() => setIsReady(true)}
                      options={{
                        defaultValues: {
                          billingDetails: {
                            name: fullName,
                            phone: contactNumber,
                            email: emailAddress,
                          },
                        },
                        layout: types["accordion"],
                        fields: {
                          billingDetails: {
                            address: {
                              email: "always",
                              name: "always",
                              phone: "always",
                              address: "always",
                            },
                          },
                        },
                      }}
                    />
                  </Box>
                </Center>
              </form>
            </>
          )}
        </>
      )}
    </>
  )
}

export default PaymentForm